module.exports = __webpack_public_path__ + "img/user.e70e2969.png";